import { useMutation } from '@tanstack/react-query';
import { useFetch } from '@/hooks/useFetch';
import type { DeleteAirRequestRequest } from '@/types/airRequestApiTypes';

export const useDeleteAirRequestMutation = () => {
  const { doFetch: deleteAirRequest } = useFetch<void, void>();

  return useMutation({
    mutationFn: (data: DeleteAirRequestRequest) =>
      deleteAirRequest(`/api/air-request/${data.id}`, {
        method: 'DELETE',
      }),
  });
};
